import { createSlice } from "@reduxjs/toolkit";
import { addDealer } from "../thunks/addDealer";
import { fetchDealers } from "../thunks/fetchDealer";



const dealerSlice=createSlice({
    name:'dealers',
    initialState:{
        isLoading:false,
        data:[],
        error:null,
    },
    extraReducers(builder){
        builder.addCase(fetchDealers.pending,(state,action)=>{
            state.isLoading=true;
        })
        builder.addCase(fetchDealers.fulfilled, (state, action) => {
           state.isLoading = false;
           state.data = action.payload;
        });
        builder.addCase(fetchDealers.rejected, (state, action) => {
           state.isLoading = false;
           state.error = action.error;
        });
        builder.addCase(addDealer.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(addDealer.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data.push(action.payload);
        });
        builder.addCase(addDealer.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.error;
        });
    }
})

export const dealersReducer=dealerSlice.reducer;